import { CommuteDataResponse } from "../api";
import { Alert } from "../api/alerts";

export type StopConfig = {
  busStops: string[];
  metroStations: string[];
  cabiStations: string[];
};

export const fetchCommuteData = async (
  location: string,
  stops: StopConfig,
): Promise<CommuteDataResponse> => {
  const params = new URLSearchParams();
  if (stops.busStops.length) params.set("busStops", stops.busStops.join(","));
  if (stops.metroStations.length) params.set("metroStations", stops.metroStations.join(","));
  if (stops.cabiStations.length) params.set("cabiStations", stops.cabiStations.join(","));

  const query = params.toString();
  const url = `/api/commute-data/${location}${query ? `?${query}` : ""}`;
  return fetch(url).then((r) => r.json()) as Promise<CommuteDataResponse>;
};

export const fetchAlerts = (): Promise<Alert[]> =>
  fetch("/api/alerts").then((r) => r.json());

export type MetroStation = { code: string; name: string; lines: string[]; lat?: number; lon?: number };
export type CabiStation = { id: string; name: string; lat?: number; lon?: number };
export type BusStop = { id: string; name: string; routes: string[]; lat?: number; lon?: number };

export const fetchMetroStations = (): Promise<MetroStation[]> =>
  fetch("/api/stops/metro").then((r) => r.json());

export const fetchCabiStations = (): Promise<CabiStation[]> =>
  fetch("/api/stops/cabi").then((r) => r.json());

export const fetchBusStopsByRoute = (route: string): Promise<BusStop[]> =>
  fetch(`/api/stops/bus?route=${encodeURIComponent(route)}`).then((r) => r.json());

export const fetchBusStopByCode = (code: string): Promise<BusStop | null> =>
  fetch(`/api/stops/bus?code=${encodeURIComponent(code)}`).then((r) =>
    r.ok ? r.json() : null,
  );

export const fetchBusStopsByLocation = (lat: number, lon: number, radius = 500): Promise<BusStop[]> =>
  fetch(`/api/stops/bus?lat=${lat}&lon=${lon}&radius=${radius}`).then((r) => r.json());
